var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/sidebar-navigation-link.tsx";
import classNames from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, Text } from './ui';
/** Desktop sidebar navigation link. */
const SidebarNavigationLink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    icon,
    text,
    to = '',
    count,
    onClick
  } = props;
  const isActive = location.pathname === to;
  const handleClick = e => {
    if (onClick) {
      onClick(e);
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    to: to,
    ref: ref,
    onClick: handleClick,
    className: classNames({
      'flex items-center p-3 text-sm font-semibold space-x-4 rounded-full group hover:bg-primary-200/80 dark:hover:bg-primary-900/60 hover:text-primary-600 dark:hover:text-gray-200 outline-offset-[-2px]': true,
      'text-gray-500 dark:text-gray-400': !isActive,
      'text-primary-600 dark:text-white': isActive
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: icon,
    count: count,
    className: classNames({
      'h-6 w-6 dark:group-hover:text-primary-500': true,
      'dark:text-primary-500': isActive
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    weight: "semibold",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, text));
});
export default SidebarNavigationLink;